
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/article/[slug]",
      function () {
        return require("private-next-pages/support/article/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/article/[slug]"])
      });
    }
  